(function () {
  'use strict';

  angular
  .module('service.date', [])

  /* @ngInject */
  .factory('DateService', function () {
    return {
      stringToDate: function (value) {
        return new Date(value.replace('T', ' ').replace('Z', '').replace(/-/g, '/'));
      },
      today: function () {
        var now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
      },
      tomorrow: function () {
        var now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      },
      nextYear: function () {
        var now = new Date();
        return new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
      },
      dateDay: function (date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      }
    };
  });

})();
